import { useCallback } from 'react'

import useUpdateAsset from './useUpdateAsset'

import { AssetsFileFragment } from '~generated/operations'
import { AssetTypes } from '~generated/types'

const useUpdateAssets = (id: string, assetType: AssetTypes) => {
  const [updateAsset, options] = useUpdateAsset()

  const updateAssets = useCallback(
    (assets: AssetsFileFragment[]) => {
      const type = assets.length > 0 && assetType === AssetTypes.COPY ? AssetTypes.ASSETS : assetType

      updateAsset({
        id,
        assets: assets?.map(({ __typename, ...rest }) => rest),
        type,
      })
    },
    [assetType, id, updateAsset]
  )

  return [updateAssets, options] as const
}

export default useUpdateAssets
